module.exports = __webpack_public_path__ + "img/circle-arrow.bedd7aa9.svg";